import React from 'react';
import { PacingQuestion } from 'sonata-react-components';

import '../pacingQuestion.scss';

type Props = {
  deviceMakeModelsEnabled: boolean;
  disabledText: string;
  enabledText: string;
  handlePacingQuestionChanged: (newStatus: boolean) => void;
  id: string;
};

export const Question: React.FC<Props> = ({
  deviceMakeModelsEnabled,
  disabledText,
  enabledText,
  handlePacingQuestionChanged,
  id
}) => {
  return (
    <PacingQuestion
      enabled={deviceMakeModelsEnabled}
      id={id}
      pacingQuestionHasChanged={handlePacingQuestionChanged}
      texts={{
        disabled: disabledText,
        enabled: enabledText
      }}
    />
  );
};
